import React from "react";
import Simple from "./Simple";

const Details = (props) => {
  return (
    <Simple
      {...props}
      fields={[
        {
          key: "discoverTitle",
          label: "discover title",
        },
        {
          key: "discoverDescription",
          label: "discover description",
          type: "textarea",
        },
      ]}
    />
  );
};

export default Details;